<template>
    <div class="tc-x-window" :style="style" ref="win">
        <div class="tc-x-window-head">
            <div class="tc-x-window-title"
                @mousedown="onMouseDown">
                {{title}}
            </div>
            <div class="tc-x-window-close"
                @click="$emit('close')">
                x
            </div>
        </div>
        <div class="tc-x-window-body">
            <slot></slot>
        </div>
    </div>
</template>
<script>

import Dragg from './dragg.js'

export default {
    name: 'Window',
    mixins: [Dragg],
    props: ['title', 'tv'],
    mounted() {
        this.ww = this.$refs.win.clientWidth
        this.wh = this.$refs.win.clientHeight
        this.x = this.tvw * 0.5 - this.ww * 0.5
        this.y = this.tvh * 0.5 - this.wh * 0.5
    },
    computed: {
        style() {
            return {
                top: `${this.y}px`,
                left: `${this.x}px`
            }
        },
        tvw() {
            return this.$props.tv.width
        },
        tvh() {
            return this.$props.tv.height
        }
    },
    data() {
        return {
            ww: 0,
            wh: 0,
            x: 0,
            y: 0,
        }
    }
}
</script>
<style>
.tc-x-window {
    position: absolute;
    /* Same lighter shadow/radius scale as the other floating chart
       windows (AddWin, GroupManager), driven by the shared --tc-* tokens
       so it tracks light/dark automatically instead of needing a separate
       hardcoded dark-mode override block below. */
    box-shadow: var(--tc-shadow-md);
    background: var(--tc-bg-elevated);
    border: 1px solid var(--tc-border-primary);
    border-radius: 10px;
    pointer-events: all;
    padding-left: 7px;
    z-index: 100;
    color: var(--tc-text-primary);
}

.tc-x-window-head {
    font-size: 2em;
    user-select: none;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    height: 32px;
    padding: 10px;
    cursor: grab;
}

.tc-x-window-body {
    padding: 10px;
    font-size: 1.1em;
}
.tc-x-window-title {
    width: 400px;
    user-select: none;
}
.tc-x-window-close {
    width: 32px;
    cursor: pointer;
    margin: -1em;
    padding: 1em;
    font-size: 0.75em;
    color: #787b86;
}
.tc-x-window-close:hover {
    color: #131722;
}
.chart-page-dark .tc-x-window-close {
    color: #787b86;
}
.chart-page-dark .tc-x-window-close:hover {
    color: #d1d4dc;
}
</style>
